<app-main-header></app-main-header>

<app-cookies-disabled-banner></app-cookies-disabled-banner>

<div *ngIf="!homePageData()">
    <p-progress-spinner></p-progress-spinner>
</div>

<router-outlet></router-outlet>
<app-main-footer></app-main-footer>
